var _t = Object.defineProperty;
var St = (e, t, n) => t in e ? _t(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var Q = (e, t, n) => St(e, typeof t != "symbol" ? t + "" : t, n);
import { CASE_IMAGE_VARIANT_KIND_KEY as $e, CASE_IMAGE_JOB_STATUS_KEY as ze, UPSCALE_TARGET_MAX_PIXELS as It, UPSCALE_TARGET_MAX_EDGE_PX as At, UPSCALE_MAX_ASPECT_RATIO as wt, PAGE_ITEM_TYPES as W, ERROR_CODE as x, PRODUCT_DEFAULT_DPI as Ue, PDF_PROGRESS_STAGES as Nt, BANNER_PROOF_PDF_MIN_PAGE_HEIGHT_INCHES as Ct, STATUS_KEY as ae, TEXT_ENTRY_INTENT_ATTRIBUTES as De, MAX_UPLOAD_FILE_SIZE as ee } from "@messenger/consts";
import Ot from "axios";
import { TokenizerMode as _, Tokenizer as bt, html as Lt, defaultTreeAdapter as R, parseFragment as Rt } from "parse5";
const ir = (e) => {
  var i, a, o;
  const t = ((i = e.city) == null ? void 0 : i.trim()) ?? "", n = ((a = e.state) == null ? void 0 : a.trim()) ?? "", s = ((o = e.postal) == null ? void 0 : o.trim()) ?? "", r = [n, s].filter(Boolean).join(" ");
  return [t, r].filter(Boolean).join(", ");
}, O = (e) => e.createdAt instanceof Date ? e.createdAt.getTime() : Date.parse(e.createdAt), Mt = (e) => e.kind === $e.UPSCALE && e.status === ze.COMPLETED && e.accepted && !!e.url, Xe = (e) => {
  let t = null;
  for (const n of e)
    Mt(n) && (t === null || O(n) > O(t)) && (t = n);
  return t;
}, xt = (e) => e.kind === $e.UPSCALE && e.status === ze.COMPLETED && !e.accepted && !!e.url, or = (e) => {
  const t = Xe(e), n = t ? O(t) : -1 / 0;
  let s = null;
  for (const r of e)
    xt(r) && (O(r) <= n || (s === null || O(r) > O(s)) && (s = r));
  return s;
}, Bt = (e) => {
  const t = Xe(e);
  return t && !t.revertedAt ? t : null;
}, ar = (e, t) => {
  const n = Bt(t);
  return n != null && n.url ? n.url : e.mioUrl || e.originalUrl;
}, we = (e) => Math.ceil(e - 1e-6), z = (e) => Number.isFinite(e.width) && Number.isFinite(e.height) && e.width > 0 && e.height > 0, lr = (e) => {
  if (!e || !z(e)) return !0;
  const t = Math.max(e.width, e.height), n = Math.min(e.width, e.height);
  return t <= n * wt;
}, kt = (e) => {
  if (!z(e))
    throw new Error("An upscale target needs a positive width and height");
  const t = Math.min(
    1,
    Math.sqrt(It / (e.width * e.height)),
    At / Math.max(e.width, e.height)
  );
  return t >= 1 ? { width: e.width, height: e.height } : {
    width: Math.max(1, Math.floor(e.width * t)),
    height: Math.max(1, Math.floor(e.height * t))
  };
}, cr = (e, t) => {
  if (!t) return null;
  if (!z(e) || !z(t))
    throw new Error("An upscale resample needs positive sizes");
  const n = Math.max(
    t.width / e.width,
    t.height / e.height
  );
  if (n <= 1) return null;
  const s = kt({
    width: we(e.width * n),
    height: we(e.height * n)
  });
  return s.width * s.height <= e.width * e.height ? null : s;
}, me = (e) => e.replace(/^https?:\/\/[^/]+/, "").replace(/\?.*$/, "").replace(/^\/+/, ""), dr = (e, t = []) => new Set(
  [e.originalUrl, e.mioUrl, e.displayUrl, ...t].filter((n) => !!n).map(me)
), vt = (e, t, n) => {
  var i, a, o;
  if (!e || e.type !== "image") return !1;
  const s = (i = e.image) == null ? void 0 : i.url;
  if (!s || (a = e.image) != null && a.editedUrl || (o = e.image) != null && o.aiVariantId) return !1;
  const r = me(s);
  return r !== n && t.has(r);
}, ur = (e, t, n) => {
  var o;
  const s = (o = e.product) == null ? void 0 : o.items;
  if (!n || t.size === 0 || !Array.isArray(s))
    return { content: e, moved: 0 };
  const r = me(n);
  let i = 0;
  const a = s.map((l) => {
    const d = l;
    return vt(d, t, r) ? (i += 1, { ...d, image: { ...d.image, url: n } }) : l;
  });
  return i === 0 ? { content: e, moved: i } : {
    content: { ...e, product: { ...e.product, items: a } },
    moved: i
  };
}, pr = (e) => e.themeMode === "SPECIFIC" ? "SPECIFIC" : e.themeMode === "ALL_PLUS_SPECIFIC" ? "ALL_PLUS_SPECIFIC" : e.themeMode === "ALL_EXCEPT" ? "ALL_EXCEPT" : e.themeMode === "ALL" || e.options.length === 0 ? "ALL" : "SPECIFIC", te = (e, t) => ({
  id: e.id,
  label: e.name,
  image: e.image,
  description: e.description,
  sortOrder: t,
  available: !0,
  dependsOn: null,
  themeId: e.id
}), fr = async (e, t, n, s) => {
  if (t === "ALL")
    return (await n()).map((u, f) => te(u, f + 1));
  if (t === "ALL_EXCEPT") {
    const c = new Set(
      e.map((f) => f.themeId).filter((f) => !!f)
    );
    return (await n()).filter((f) => !c.has(f.id)).map((f, y) => te(f, y + 1));
  }
  const r = e.map((c) => c.themeId).filter((c) => !!c), i = await s(r), a = new Map(i.map((c) => [c.id, c])), o = [];
  for (const c of e) {
    const u = c.themeId ? a.get(c.themeId) : null;
    u && o.push({
      ...c,
      id: u.id,
      label: u.name,
      image: c.image ?? u.image,
      description: c.description ?? u.description
    });
  }
  if (t === "SPECIFIC") return o;
  const l = await n(), d = new Set(
    o.map((c) => c.themeId).filter((c) => !!c)
  ), p = l.filter((c) => !d.has(c.id)).map((c, u) => te(c, u + 1));
  return [...o, ...p].sort(
    (c, u) => (c.sortOrder ?? Number.MAX_SAFE_INTEGER) - (u.sortOrder ?? Number.MAX_SAFE_INTEGER)
  );
}, mr = (e, t) => !e || !Array.isArray(e) ? [] : e.filter((n) => {
  if (!n.dependsOn) return !0;
  let s = [];
  try {
    s = Array.isArray(n.dependsOn) ? n.dependsOn : JSON.parse(
      n.dependsOn
    );
  } catch {
    return !0;
  }
  return s.every((r) => {
    const i = t[r.customizationLabel];
    return !!i && r.optionLabels.includes(i);
  });
}), hr = (e, t) => {
  const n = [];
  let s, r;
  return Object.entries(e).forEach(
    ([i, a]) => {
      const o = t.find((d) => d.label === i);
      if (!o) return;
      const l = {
        label: i,
        customization_id: o.id,
        selected_option: a
      };
      switch (o.customizationType) {
        case "BASE":
        case "ENHANCEMENT":
        case "DYNAMIC_CONTENT":
          n.push(l);
          break;
        case "THEME":
          s = a;
          break;
        case "TEMPLATE":
          r = a, n.push(l);
          break;
      }
    }
  ), { customizations: n, themeId: s, templateId: r };
}, Pt = (e) => JSON.stringify(le(V(e))), V = (e) => {
  if (typeof e != "string") return e;
  try {
    return JSON.parse(e);
  } catch {
    return e;
  }
}, le = (e) => {
  if (Array.isArray(e)) return e.map(le);
  if (e !== null && typeof e == "object") {
    const t = /* @__PURE__ */ Object.create(null);
    for (const n of Object.keys(e).sort())
      t[n] = le(e[n]);
    return t;
  }
  return e;
}, gr = (e) => {
  const t = e.map((o) => ({
    id: o.id,
    pointsAtId: o.currentOrderPageSetIdUsed,
    body: JSON.stringify({
      name: o.name,
      pageSetId: o.pageSetId,
      globalTemplateId: o.globalTemplateId,
      funeralHomeTemplateId: o.funeralHomeTemplateId,
      productId: o.productId,
      language: o.language,
      pages: [...o.pages].sort((l, d) => l.pageNumber - d.pageNumber).map((l) => ({
        pageNumber: l.pageNumber,
        columns: l.columns,
        rows: l.rows,
        gridStartPointTop: l.gridStartPointTop,
        gridStartPointLeft: l.gridStartPointLeft,
        content: Pt(l.content ?? null),
        ...l.textBoxes ? { textBoxes: l.textBoxes } : {}
      }))
    })
  })), n = new Map(t.map((o) => [o.id, o.body])), s = t.map((o) => ({
    body: o.body,
    targetBody: o.pointsAtId === null ? null : n.get(o.pointsAtId) ?? null
  })), r = (o, l) => o < l ? -1 : o > l ? 1 : 0, i = [...s].sort(
    (o, l) => r(o.body, l.body) || r(o.targetBody ?? "", l.targetBody ?? "")
  ), a = (o) => o === null ? null : i.findIndex((l) => l.body === o);
  return JSON.stringify(
    i.map((o) => ({
      body: o.body,
      pointsAt: a(o.targetBody)
    }))
  );
}, Ge = (e) => {
  var n;
  const t = (n = e == null ? void 0 : e.product) == null ? void 0 : n.items;
  return Array.isArray(t) ? t : [];
}, je = (e) => {
  const t = e;
  return (t == null ? void 0 : t.type) !== W.editorTextBox ? null : typeof t.id == "string" ? t.id : null;
}, Ft = (e) => Ht(V(e)), Ht = (e) => {
  const t = [];
  for (const n of Ge(e)) {
    const s = je(n);
    s !== null && t.push(s);
  }
  return t;
}, Er = (e, t) => {
  const n = new Set(t ?? []);
  return new Set(e.filter((s) => !n.has(s)));
}, $t = (e, t) => {
  if (t.size === 0) return e;
  const n = V(e), s = Ge(n), r = s.filter((o) => {
    const l = je(o);
    return l === null || !t.has(l);
  });
  if (r.length === s.length) return e;
  const i = n, a = {
    ...i,
    product: { ...i.product, items: r }
  };
  return typeof e == "string" ? JSON.stringify(a) : a;
}, zt = (e) => {
  var s;
  let t = e;
  if (typeof e == "string")
    try {
      t = JSON.parse(e);
    } catch {
      return;
    }
  const n = (s = t == null ? void 0 : t.pageProperties) == null ? void 0 : s.lotusTurnoverRunId;
  return typeof n == "string" && n !== "" ? n : void 0;
}, Ut = (e) => ({
  stubIds: Ft(e),
  runId: zt(e)
}), Tr = (e, t = {}) => {
  var d;
  const { stubIds: n, runId: s } = Ut(e), r = new Set(
    n.filter((p) => {
      var c;
      return !((c = t.stubIds) != null && c.has(p));
    })
  ), i = $t(e, r);
  if (s === void 0 || (d = t.runIds) != null && d.has(s)) return i;
  const a = V(i), o = { ...a.pageProperties };
  delete o.lotusTurnoverRunId;
  const l = { ...a, pageProperties: o };
  return typeof e == "string" ? JSON.stringify(l) : l;
}, Dt = {
  BAD_REQUEST: { httpStatus: 400, trpcCode: "BAD_REQUEST" },
  UNAUTHORIZED: { httpStatus: 401, trpcCode: "UNAUTHORIZED" },
  FORBIDDEN: { httpStatus: 403, trpcCode: "FORBIDDEN" },
  NOT_FOUND: { httpStatus: 404, trpcCode: "NOT_FOUND" },
  CONFLICT: { httpStatus: 409, trpcCode: "CONFLICT" },
  PRECONDITION_FAILED: { httpStatus: 412, trpcCode: "PRECONDITION_FAILED" },
  GONE: { httpStatus: 410, trpcCode: "NOT_FOUND" },
  TOO_MANY_REQUESTS: { httpStatus: 429, trpcCode: "TOO_MANY_REQUESTS" },
  UNSUPPORTED_IMAGE_FORMAT: { httpStatus: 422, trpcCode: "BAD_REQUEST" },
  FILE_TOO_LARGE: { httpStatus: 413, trpcCode: "PAYLOAD_TOO_LARGE" },
  IMAGE_IN_USE_BY_LAYOUT: { httpStatus: 409, trpcCode: "CONFLICT" },
  LAYOUT_TEXT_NOT_AVAILABLE: { httpStatus: 409, trpcCode: "CONFLICT" },
  AI_IMAGE_EDITS_DISABLED: { httpStatus: 403, trpcCode: "FORBIDDEN" },
  INTERNAL_SERVER_ERROR: { httpStatus: 500, trpcCode: "INTERNAL_SERVER_ERROR" }
}, Xt = (e, t, n, s, r, i) => {
  const a = new Error(e);
  return a.name = "AppError", a.code = t, a.status = n, a.data = r, a.trpcCode = s, i !== void 0 && (a.cause = i), a;
}, We = (e) => {
  const t = Dt[e.code];
  throw Xt(
    e.message,
    e.code,
    t.httpStatus,
    t.trpcCode,
    e.data,
    e.cause
  );
}, Gt = (e) => e instanceof Error && "code" in e && "status" in e && e.name === "AppError", jt = 1e3, Wt = 2e3, Ve = (e, t) => e.length > t ? e.slice(0, t) + "..." : e, Vt = (e) => {
  if (!e) return null;
  const t = e.replace(
    /\/(Users|home|var|tmp|opt)\/[^\s:)]+/g,
    "<path>"
  );
  return Ve(t, Wt);
}, A = (e, t, n, s, r, i) => ({
  message: Ve(e, jt),
  errorName: t,
  code: n,
  stack: Vt(r),
  timestamp: (/* @__PURE__ */ new Date()).toISOString(),
  httpStatus: s,
  ...i ? { data: i } : {}
}), w = (e, t, n, s) => ({ message: e, code: t, httpStatus: n, sanitizedLoggingOutput: s }), Ne = (e) => typeof e == "string" && Object.values(x).includes(e), yr = (e) => {
  var s, r, i, a, o;
  if (Gt(e)) {
    const l = A(
      e.message,
      e.name,
      e.code,
      e.status,
      e.stack,
      e.data
    );
    return w(e.message, e.code, e.status, l);
  }
  if (Ot.isAxiosError(e)) {
    const l = (s = e.response) == null ? void 0 : s.data, d = (l == null ? void 0 : l.message) ?? e.message, p = Ne(l == null ? void 0 : l.code) ? l.code : null, c = ((r = e.response) == null ? void 0 : r.status) ?? 500, u = A(
      d,
      e.name,
      p,
      c,
      e.stack
    );
    return w(d, p, c, u);
  }
  if (e instanceof Error && "data" in e) {
    const l = e, d = ((i = l.data) == null ? void 0 : i.appErrorCode) ?? ((a = l.data) == null ? void 0 : a.code) ?? null, p = Ne(d) ? d : null, c = ((o = l.data) == null ? void 0 : o.httpStatus) ?? 500, u = A(
      e.message,
      e.name,
      p,
      c,
      e.stack
    );
    return w(e.message, p, c, u);
  }
  if (e instanceof Error) {
    const l = A(
      e.message,
      e.name,
      null,
      500,
      e.stack
    );
    return w(e.message, null, 500, l);
  }
  if (typeof e == "string") {
    const l = A(e, "StringError", null, 500, void 0);
    return w(e, null, 500, l);
  }
  let t;
  if (e && typeof e == "object") {
    const l = e.message;
    if (typeof l == "string")
      t = l;
    else
      try {
        t = JSON.stringify(e);
      } catch {
        t = String(e);
      }
  } else
    t = String(e);
  const n = A(t, "UnknownError", null, 500, void 0);
  return w(t, null, 500, n);
}, Yt = (e) => new Promise((t) => setTimeout(t, e)), Kt = async (e, {
  isRetryable: t,
  maxAttempts: n = 3,
  baseDelayMs: s = 300,
  backoffFactor: r = 2,
  jitterRatio: i = 0.25,
  onRetry: a
}) => {
  if (!Number.isInteger(n) || n < 1)
    throw new Error(
      `retryWithBackoff: maxAttempts must be a positive integer (got ${n})`
    );
  let o;
  for (let l = 1; l <= n; l++)
    try {
      return await e();
    } catch (d) {
      if (o = d, !t(d) || l === n)
        throw d;
      a == null || a(l, n, d);
      const p = s * r ** (l - 1), c = p * i * (Math.random() * 2 - 1);
      await Yt(Math.max(0, p + c));
    }
  throw o instanceof Error ? o : new Error("retryWithBackoff exhausted its attempts");
}, $ = {
  clergy: "clergy",
  siblings: "siblings",
  children: "children",
  /**
   * Canonical bucket for flat name+relation entries created through the
   * M3 Additional Family input. Coexists with historical types ('other',
   * free-form group names, MIP singular relations, the legacy ' ' type) —
   * those keep their values so the MDL grouped-by-type UI is unchanged.
   */
  additionalFamily: "additional_family"
}, qt = (e, t) => (e ?? "").trim().toLowerCase() === t.trim().toLowerCase(), Jt = [
  $.clergy,
  $.siblings,
  $.children
], _r = (e) => Jt.some((t) => qt(e, t)), Zt = /* @__PURE__ */ new Set([
  "",
  "other",
  "additional family",
  $.additionalFamily
]), Qt = (e) => Zt.has(M(e)), M = (e) => (e ?? "").trim().toLowerCase(), en = (e) => (e ?? "").split(" ").map(
  (t) => t && t[0].toUpperCase() + t.slice(1).toLowerCase()
).join(" "), Sr = (e) => typeof e.type == "string" ? { ...e, type: e.type.trim().toLowerCase() } : e, Ir = (e, t) => (e ?? []).map((n) => n.trim()).filter((n) => n.length > 0).map((n) => ({ name: n, type: t })), Ar = [
  "Aunt",
  "Grandchild",
  "Granddaughter",
  "Grandson",
  "Nephew",
  "Niece",
  "Uncle",
  "Other"
], wr = (e) => {
  const t = (e.name ?? "").trim(), n = (e.relation ?? "").trim();
  if (n) return t ? `${t}, ${n}` : n;
  if (!Qt(e.type)) {
    const s = en((e.type ?? "").trim());
    return t ? `${t}, ${s}` : s;
  }
  return t;
}, Ce = (e) => e.replace(/[\u200B-\u200D\uFEFF]/g, ""), Nr = (e, t, n) => {
  const s = Ce((t == null ? void 0 : t.name) ?? "").trim();
  if (!s) return e;
  const r = Ce((t == null ? void 0 : t.relation) ?? "").trim() || null, i = t == null ? void 0 : t.editingIndex;
  if (i != null && e[i]) {
    const a = [...e];
    return a[i] = { ...a[i], name: s, relation: r }, a;
  }
  return [...e, n(s, r)];
}, Cr = (e, t) => {
  const n = new Set(
    t.map((r) => r.id).filter(Boolean)
  ), s = e.filter((r) => !n.has(r.id));
  return t.map((r) => {
    if (r.id) return r;
    const i = s.findIndex(
      (o) => M(o.type) === M(r.type) && o.name.trim().toLowerCase() === (r.name ?? "").trim().toLowerCase()
    );
    if (i === -1) return r;
    const [a] = s.splice(i, 1);
    return { ...r, id: a.id };
  });
}, Or = (e, t) => Object.entries(t).every(([n, s]) => n === "id" ? !0 : n === "type" ? M(e.type) === M(s) : (e[n] ?? null) === (s ?? null)), tn = (e) => Math.round(e * Ue), br = (e) => typeof e == "number" && Number.isFinite(e) && e > 0 ? tn(e) : null, nn = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
}, he = (e) => e.replace(/[&<>"']/g, (t) => nn[t]), sn = (e) => {
  const t = /<Section\b/i.exec(e);
  return t !== null && e.indexOf(">", t.index) !== -1;
}, ge = (e) => {
  if (typeof e != "string") return !1;
  const t = sn(e) && /<(?:Paragraph|Run)\b/i.test(e), n = /xmlns\s*=\s*["'][^"']*schemas\.microsoft\.com\/winfx/i.test(e);
  return t || n;
}, Oe = (e, t) => !Number.isInteger(t) || t < 0 || t > 1114111 || t >= 55296 && t <= 57343 ? e : t < 32 && t !== 9 && t !== 10 && t !== 13 ? "" : String.fromCodePoint(t), Ee = (e) => e.replace(
  /&#x([0-9a-fA-F]+);/g,
  (t, n) => Oe(t, parseInt(n, 16))
).replace(
  /&#(\d+);/g,
  (t, n) => Oe(t, parseInt(n, 10))
).replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '"').replace(/&apos;/g, "'").replace(/&amp;/g, "&"), Ye = (e) => /FontWeight\s*=\s*["'](?:Bold|SemiBold|DemiBold|ExtraBold|UltraBold|Black|Heavy|Medium|[6-9]\d0)["']/i.test(
  e
), Ke = (e) => /FontStyle\s*=\s*["'](?:Italic|Oblique)["']/i.test(e), g = {
  strongOpen: "",
  strongClose: "",
  emOpen: "",
  emClose: "",
  br: ""
}, rn = (e) => e.split(g.strongOpen).join("<strong>").split(g.strongClose).join("</strong>").split(g.emOpen).join("<em>").split(g.emClose).join("</em>").split(g.br).join("<br>"), be = (e) => {
  let t = e;
  return t = t.replace(/<Run\b[^>]*\/>/gi, ""), t = t.replace(
    /<Run\b([^>]*)>([^<]*)<\/Run>/gi,
    (n, s, r) => {
      let i = r;
      return Ke(s) && (i = `${g.emOpen}${i}${g.emClose}`), Ye(s) && (i = `${g.strongOpen}${i}${g.strongClose}`), i;
    }
  ), t = t.replace(/<LineBreak\b[^>]*\/?>/gi, g.br), t = t.replace(/<Bold\b[^>]*>/gi, g.strongOpen).replace(/<\/Bold>/gi, g.strongClose), t = t.replace(/<Italic\b[^>]*>/gi, g.emOpen).replace(/<\/Italic>/gi, g.emClose), t = t.replace(/<[^>]+>/g, ""), t = he(Ee(t)), rn(t).trim();
}, Te = (e) => {
  const t = [];
  let n = -1;
  for (let i = 0; i < e.length; i++) {
    const a = e.charCodeAt(i);
    a === 60 ? (n !== -1 && t.push(n), n = i) : a === 62 && (n = -1);
  }
  if (n !== -1 && t.push(n), t.length === 0) return e;
  let s = "", r = 0;
  for (const i of t)
    s += e.slice(r, i) + "&lt;", r = i + 1;
  return s + e.slice(r);
}, on = (e) => {
  const t = [], n = /<Paragraph\b[^>]*?(\/?)>/gi, s = /<\/Paragraph>/gi;
  let r = !1, i;
  for (; (i = n.exec(e)) !== null; ) {
    if (i[1] === "/") {
      t.push(void 0);
      continue;
    }
    if (r) continue;
    s.lastIndex = n.lastIndex;
    const a = s.exec(e);
    if (a === null) {
      r = !0;
      continue;
    }
    t.push(e.slice(n.lastIndex, a.index)), n.lastIndex = s.lastIndex;
  }
  return t;
}, qe = 1e5, an = (e) => {
  let t = "", n = !1;
  for (const s of e)
    s === "<" ? n = !0 : s === ">" ? n = !1 : n || (t += s);
  return t;
}, ln = (e) => {
  if (!ge(e)) return typeof e == "string" ? e : "";
  if (e.length > qe) {
    const s = he(Ee(an(e))).trim();
    return s ? `<p>${s}</p>` : "";
  }
  const t = Te(e).replace(/<\/?Section\b[^>]*>/gi, ""), n = on(t).map(
    (s) => s === void 0 ? "" : be(s)
  );
  if (n.length === 0) {
    const s = be(t);
    return s ? `<p>${s}</p>` : "";
  }
  return n.map((s) => `<p>${s}</p>`).join("");
}, cn = /[A-Za-z/!?]/, Le = (e) => {
  const t = Te(e);
  let n = "", s = !1;
  for (let r = 0; r < t.length; r++) {
    const i = t[r] ?? "";
    s ? i === ">" && (s = !1) : i === "<" && cn.test(t[r + 1] ?? "") ? s = !0 : n += i;
  }
  return Ee(n).replace(/\s+/g, "");
}, Je = "address|article|aside|blockquote|center|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|h[1-6]|header|hgroup|hr|li|listing|main|menu|nav|ol|p|plaintext|pre|search|section|summary|table|ul|xmp", dn = new RegExp(`<(${Je})\\b([^<>]*)`, "gi"), un = new RegExp(`<(${Je}|br|tr)\\b([^<>]*)`, "gi"), pn = /* @__PURE__ */ new Set(["Section", "Table", "Figure"]), fn = /xmlns\s*=\s*["'][^"']*schemas\.microsoft\.com\/winfx/i, Ze = (e, t) => {
  t.lastIndex = 0;
  let n;
  for (; (n = t.exec(e)) !== null; )
    if (!(pn.has(n[1] ?? "") || fn.test(n[2] ?? ""))) return !0;
  return !1;
}, mn = (e) => {
  if (e.length > qe || Ze(e, un))
    return null;
  const t = ln(e);
  return Le(t) === Le(e) ? t : null;
}, hn = (e) => {
  const t = e.split(/(<\/?Paragraph\b[^>]*>)/i);
  let n = "p";
  return t.map((s, r) => {
    if (r % 2 === 0) return s;
    if (s.endsWith("/>")) return "<p></p>";
    if (s[1] === "/") {
      const i = `</${n}>`;
      return n = "p", i;
    }
    return n = Ze(t[r + 1] ?? "", dn) ? "div" : "p", `<${n}>`;
  }).join("");
}, gn = (e) => hn(Te(e)).replace(
  /<Run\b([^>]*)>([^<]*)<\/Run>/gi,
  (t, n, s) => {
    let r = s;
    return Ke(n) && (r = `<em>${r}</em>`), Ye(n) && (r = `<strong>${r}</strong>`), r;
  }
).replace(/<LineBreak\b[^>]*>/gi, "<br>").replace(/<(\/?)Bold\b[^>]*>/gi, "<$1strong>").replace(/<(\/?)Italic\b[^>]*>/gi, "<$1em>"), Lr = (e, t) => {
  if (e == null) return e;
  let n = e, s = !1;
  if (typeof e == "string") {
    s = !0;
    try {
      n = JSON.parse(e);
    } catch {
      return e;
    }
  }
  if (!n || typeof n != "object") return e;
  const r = JSON.parse(JSON.stringify(n));
  return r.product && typeof r.product == "object" && (r.product.pageId = t.targetPageId, r.product.themeOverride && typeof r.product.themeOverride == "object" && (delete r.product.themeOverride.product_id, delete r.product.themeOverride.m3_product_id, delete r.product.themeOverride.productId, delete r.product.themeOverride.m3ProductId, t.targetIsM3 ? (r.product.themeOverride.m3_product_id = t.targetProductId, r.product.themeOverride.m3ProductId = t.targetProductId) : (r.product.themeOverride.product_id = t.targetProductId, r.product.themeOverride.productId = t.targetProductId))), r.pageProperties && typeof r.pageProperties == "object" && (r.pageProperties.pageSetId = t.targetTemplateId), s ? JSON.stringify(r) : r;
}, Rr = (e, t = 0) => {
  const { start: n, end: s } = Nt[e];
  return Math.round(n + (s - n) * t);
}, En = (e) => typeof e == "number" && Number.isFinite(e) && e >= 0, Mr = (e, t = "$0.00") => En(e) ? `$${(e / 100).toFixed(2)}` : t, xr = (e) => {
  if (!Array.isArray(e) || e.length === 0 || typeof document > "u" || typeof window > "u") return;
  const t = document.createElement("style");
  t.setAttribute("data-proof-print", "true"), t.textContent = `
    .proof-print-root { display: none; }
    @media print {
      @page { margin: 0; size: auto; }
      body > *:not(.proof-print-root) { display: none !important; }
      .proof-print-root { display: block !important; }
      .proof-print-page {
        width: 100vw;
        height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        page-break-after: always;
        break-after: page;
        page-break-inside: avoid;
        break-inside: avoid;
      }
      .proof-print-page:last-child { page-break-after: auto; break-after: auto; }
      .proof-print-page img {
        max-width: 100%;
        max-height: 100%;
        width: auto;
        height: auto;
        object-fit: contain;
        display: block;
      }
    }
  `;
  const n = document.createElement("div");
  n.className = "proof-print-root", e.forEach((o, l) => {
    const d = document.createElement("div");
    d.className = "proof-print-page";
    const p = document.createElement("img");
    p.src = o, p.alt = `Proof page ${l + 1}`, d.appendChild(p), n.appendChild(d);
  }), document.head.appendChild(t), document.body.appendChild(n);
  const s = () => {
    n.remove(), t.remove(), window.removeEventListener("afterprint", s);
  };
  window.addEventListener("afterprint", s);
  const r = Array.from(n.querySelectorAll("img"));
  let i = r.length;
  const a = () => window.print();
  if (i === 0) {
    a();
    return;
  }
  r.forEach((o) => {
    if (o.complete)
      --i === 0 && a();
    else {
      const l = () => {
        --i === 0 && a();
      };
      o.addEventListener("load", l, { once: !0 }), o.addEventListener("error", l, { once: !0 });
    }
  });
}, Br = (e, t, n, s, r, i, a, o, l) => {
  const d = {
    isOverlapping: !1,
    bleedType: null,
    location: null
  };
  if (!r || !(n > 0 && s > 0 && i > 0 && a > 0 && !isNaN(e) && !isNaN(t))) return d;
  const c = (o == null ? void 0 : o.left) ?? 0, u = (o == null ? void 0 : o.top) ?? 0, f = e + c, y = e + n + c, Ie = t + u, Ae = t + s + u, ht = r.margin_top && r.margin_top > 0, gt = r.margin_left && r.margin_left > 0, Et = r.margin_right && r.margin_right > 0, Tt = r.margin_bottom && r.margin_bottom > 0;
  if (ht) {
    const h = r.margin_top;
    if (Ie < h)
      return {
        isOverlapping: !0,
        bleedType: "edge",
        location: "top"
      };
  }
  if (gt) {
    const h = r.margin_left;
    if (f < h)
      return {
        isOverlapping: !0,
        bleedType: "edge",
        location: "left"
      };
  }
  if (Et) {
    const h = i - r.margin_right;
    if (y > h)
      return {
        isOverlapping: !0,
        bleedType: "edge",
        location: "right"
      };
  }
  if (Tt) {
    const h = a - r.margin_bottom;
    if (Ae > h)
      return {
        isOverlapping: !0,
        bleedType: "edge",
        location: "bottom"
      };
  }
  if (l)
    return l.some(
      (E) => f < E.end && y > E.start
    ) ? { isOverlapping: !0, bleedType: "center", location: "fold" } : d;
  if (r.margin_center_vertical != null && r.margin_center_vertical > 0) {
    const h = i / 2, E = r.margin_center_vertical / 2, K = h - E, q = h + E, J = f < q, Z = y > K;
    if (J && Z)
      return {
        isOverlapping: !0,
        bleedType: "center",
        location: "centerVertical"
      };
  }
  if (r.margin_center_horizontal != null && r.margin_center_horizontal > 0) {
    const h = a / 2, E = r.margin_center_horizontal / 2, K = h - E, q = h + E, J = Ie < q, Z = Ae > K;
    if (J && Z)
      return {
        isOverlapping: !0,
        bleedType: "center",
        location: "centerHorizontal"
      };
  }
  return d;
}, Tn = W.text, yn = W.qrCode, _n = W.editorTextBox, Sn = /* @__PURE__ */ new Set([
  Tn,
  yn,
  _n
]), Qe = 1, ne = {
  margin: "margin",
  fold: "fold",
  preexisting: "preexisting"
}, T = (e) => typeof e == "number" && Number.isFinite(e), kr = ({
  box: e,
  items: t,
  margins: n,
  pageHeight: s,
  padding: r
}) => {
  const i = T(e.height) && e.height > 0 ? e.height : 0;
  if (!T(e.x) || !T(e.y) || !T(e.width))
    return { maxHeight: i, boundedBy: null };
  const a = e.y + ((r == null ? void 0 : r.top) ?? 0), o = T(s) && s > 0, l = [];
  if (o) {
    const c = n == null ? void 0 : n.margin_bottom;
    T(c) && c > 0 ? l.push({
      maxHeight: s - c - a,
      boundedBy: ne.margin
    }) : l.push({
      maxHeight: s - a,
      boundedBy: null
    });
    const u = n == null ? void 0 : n.margin_center_horizontal;
    if (T(u) && u > 0) {
      const f = s / 2 - u / 2;
      a < f && l.push({
        maxHeight: f - a,
        boundedBy: ne.fold
      });
    }
  }
  for (const c of Array.isArray(t) ? t : [])
    !c || !Sn.has(c.type ?? "") || e.id != null && c.id === e.id || !T(c.x) || !T(c.y) || !T(c.width) || c.y <= e.y || !(c.x < e.x + e.width && c.x + c.width > e.x) || l.push({ maxHeight: c.y - e.y, boundedBy: c.id });
  if (l.length === 0)
    return { maxHeight: i, boundedBy: null };
  let d = l[0];
  for (const c of l)
    c.maxHeight < d.maxHeight && (d = c);
  const p = i - d.maxHeight;
  if (p > Qe) {
    const c = e.lineHeight;
    return {
      maxHeight: d.maxHeight,
      boundedBy: ne.preexisting,
      kept: {
        ceiling: d.maxHeight,
        boundedBy: d.boundedBy,
        lineHeight: T(c) && c > 0 ? c : null
      }
    };
  }
  return p > 0 ? { maxHeight: i, boundedBy: d.boundedBy } : { maxHeight: d.maxHeight, boundedBy: d.boundedBy };
}, In = [
  "itemState",
  "facesLoaded",
  "facesSettled",
  "stylesSettled",
  "runLineHeight",
  "blocks",
  "anatomy",
  "contentHeightAtOne",
  "measuredAtOne",
  "loadFit"
], An = (e) => e ? `${e.x},${e.y},${e.width}` : null, wn = (e) => {
  const t = {};
  if (e.kind === "tinymce" && e.autosize)
    for (const r of In) {
      const i = e.autosize[r];
      i !== void 0 && (t[r] = i);
    }
  const n = e.kind === "lotus" ? e.fit : e.autosize, s = An(n == null ? void 0 : n.ceilingFrom);
  return s !== null && (t.ceilingFrom = s), Object.keys(t).length > 0 ? t : null;
}, N = (e, t = 2) => {
  const n = 10 ** t;
  return Math.round(e * n) / n;
}, Nn = 4 / 3, Cn = (e) => {
  var s, r, i, a, o;
  const t = e.kind === "lotus" ? e.fit : e.autosize, n = e.kind === "lotus" ? e.textFont ? [N(e.textFont.sizePx / Nn)] : null : ((s = e.autosize) == null ? void 0 : s.fontSizesPt.map((l) => N(l))) ?? null;
  return {
    itemId: e.itemId,
    kind: e.kind,
    pageIndex: e.pageIndex,
    pageId: e.pageId ?? null,
    settled: e.settled,
    frame: {
      x: N(e.frame.x),
      y: N(e.frame.y),
      width: N(e.frame.width),
      height: N(e.frame.height)
    },
    fontSizesPt: n,
    scale: e.kind === "lotus" ? ((r = e.fit) == null ? void 0 : r.scale) ?? null : null,
    lines: e.complete ? e.lines.length : null,
    loadHeight: (t == null ? void 0 : t.loadHeight) ?? null,
    ceiling: (t == null ? void 0 : t.ceiling) ?? null,
    boundedBy: (t == null ? void 0 : t.boundedBy) ?? null,
    overflowing: On(e),
    kept: (t == null ? void 0 : t.kept) ?? null,
    sizing: e.kind === "lotus" ? ((i = e.fit) == null ? void 0 : i.sizing) ?? null : null,
    maxFontSizePt: e.kind === "lotus" ? ((a = e.fit) == null ? void 0 : a.maxFontSizePt) ?? null : null,
    passes: e.kind === "tinymce" ? ((o = e.autosize) == null ? void 0 : o.passes) ?? null : null,
    textHash: e.textHash,
    stamps: wn(e)
  };
}, On = (e) => {
  var n, s;
  if (e.kind === "lotus") return ((n = e.fit) == null ? void 0 : n.overflowing) ?? null;
  const t = ((s = e.autosize) == null ? void 0 : s.itemState) ?? null;
  return t === null || t === "loading" ? null : t === "content-overflowing";
}, vr = (e, t, n = null) => ({
  surface: e,
  takenAt: n,
  boxes: t.map(Cn)
}), se = {
  px: Qe,
  pt: 0.05,
  scale: 5e-4
}, v = (e) => `${e.pageId ?? e.pageIndex}:${e.itemId}`, Re = (e) => ({
  itemId: e.itemId,
  kind: e.kind,
  pageIndex: e.pageIndex,
  pageId: e.pageId ?? null,
  settled: e.settled === !0,
  frame: e.frame,
  fontSizesPt: e.fontSizesPt ?? null,
  scale: e.scale ?? null,
  lines: e.lines ?? null,
  loadHeight: e.loadHeight ?? null,
  ceiling: e.ceiling ?? null,
  boundedBy: e.boundedBy ?? null,
  overflowing: e.overflowing ?? null,
  kept: e.kept ?? null,
  sizing: e.sizing ?? null,
  maxFontSizePt: e.maxFontSizePt ?? null,
  passes: e.passes ?? null,
  textHash: e.textHash ?? null,
  stamps: e.stamps ?? null
}), I = (e, t, n) => Math.abs(e - t) > n, U = (e) => Array.from(new Set(e.map((t) => Math.round(t * 100) / 100))).sort(
  (t, n) => t - n
), bn = (e, t, n) => {
  const s = U(e), r = U(t);
  return s.length !== r.length ? !0 : s.some((i, a) => I(i, r[a], n));
}, b = {
  /** A frame edge or a load height within this many px, or this share of the height, is renderer noise. */
  px: 4,
  ratio: 0.02
}, P = (e, t) => Math.abs(e - t) > Math.max(b.px, Math.abs(e) * b.ratio), Ln = (e, t) => {
  const n = U(e), s = U(t);
  return n.length !== s.length ? !0 : n.some(
    (r, i) => Math.abs(r - s[i]) > r * b.ratio
  );
}, Rn = (e) => {
  for (const t of e) {
    if (t.field === "text" || t.field === "lines" || t.field === "boundedBy" || t.field === "overflowing" || t.field === "sizing" || t.field === "maxFontSizePt")
      return "different";
    if (t.field === "kept") {
      const n = t.before, s = t.after;
      if (n.boundedBy !== s.boundedBy || P(n.ceiling, s.ceiling))
        return "different";
      continue;
    }
    if (t.field === "fontSizesPt") {
      if (Ln(
        t.before,
        t.after
      ))
        return "different";
      continue;
    }
    if (t.field === "scale") {
      const n = t.before, s = t.after;
      if (Math.abs(n - s) > n * b.ratio)
        return "different";
      continue;
    }
    if (t.field === "loadHeight") {
      if (P(t.before, t.after))
        return "different";
      continue;
    }
    if (t.field === "frame") {
      const n = t.before, s = t.after;
      if (P(n.height, s.height) || P(n.width, s.width) || Math.abs(n.x - s.x) > b.px || Math.abs(n.y - s.y) > b.px)
        return "different";
    }
  }
  return "noise";
}, Mn = (e, t, n = {}) => {
  const s = n.px ?? se.px, r = n.pt ?? se.pt, i = n.scale ?? se.scale;
  if (e.textHash !== null && t.textHash !== null && e.textHash !== t.textHash)
    return [{ field: "text", before: e.textHash, after: t.textHash }];
  const a = [];
  return e.fontSizesPt !== null && t.fontSizesPt !== null && bn(e.fontSizesPt, t.fontSizesPt, r) && a.push({
    field: "fontSizesPt",
    before: e.fontSizesPt,
    after: t.fontSizesPt
  }), e.scale !== null && t.scale !== null && I(e.scale, t.scale, i) && a.push({ field: "scale", before: e.scale, after: t.scale }), (I(e.frame.x, t.frame.x, s) || I(e.frame.y, t.frame.y, s) || I(e.frame.width, t.frame.width, s) || I(e.frame.height, t.frame.height, s)) && a.push({ field: "frame", before: e.frame, after: t.frame }), e.lines !== null && t.lines !== null && e.lines !== t.lines && a.push({ field: "lines", before: e.lines, after: t.lines }), e.loadHeight !== null && t.loadHeight !== null && I(e.loadHeight, t.loadHeight, s) && a.push({
    field: "loadHeight",
    before: e.loadHeight,
    after: t.loadHeight
  }), e.boundedBy !== null && t.boundedBy !== null && e.boundedBy !== t.boundedBy && a.push({
    field: "boundedBy",
    before: e.boundedBy,
    after: t.boundedBy
  }), e.overflowing !== null && t.overflowing !== null && e.overflowing !== t.overflowing && a.push({
    field: "overflowing",
    before: e.overflowing,
    after: t.overflowing
  }), e.kept !== null && t.kept !== null && xn(e.kept, t.kept, s) && a.push({ field: "kept", before: e.kept, after: t.kept }), e.sizing !== null && t.sizing !== null && (e.sizing !== t.sizing && a.push({
    field: "sizing",
    before: e.sizing,
    after: t.sizing
  }), e.maxFontSizePt !== t.maxFontSizePt && a.push({
    field: "maxFontSizePt",
    before: e.maxFontSizePt,
    after: t.maxFontSizePt
  })), a;
}, xn = (e, t, n) => e.boundedBy !== t.boundedBy || I(e.ceiling, t.ceiling, n) || e.lineHeight !== null && t.lineHeight !== null && I(e.lineHeight, t.lineHeight, n), Bn = (e, t) => `${e.kind} ${e.itemId.slice(0, 8)}: ${t.map(
  (n) => `${n.field} ${JSON.stringify(n.before)}→${JSON.stringify(n.after)}`
).join("; ")}`, Pr = (e, t, n = {}) => {
  const s = e.boxes.map(Re), r = t.boxes.map(Re), i = new Map(r.map((u) => [v(u), u])), a = new Set(s.map(v)), o = [], l = [], d = [];
  let p = 0;
  for (const u of s) {
    const f = i.get(v(u));
    if (!f) {
      l.push(u.itemId);
      continue;
    }
    if (!u.settled || !f.settled) {
      d.push(u.itemId);
      continue;
    }
    p += 1;
    const y = Mn(u, f, n);
    y.length > 0 && o.push({
      itemId: u.itemId,
      kind: u.kind,
      pageIndex: u.pageIndex,
      pageId: u.pageId ?? f.pageId,
      deltas: y,
      severity: Rn(y),
      summary: Bn(u, y)
    });
  }
  const c = r.filter((u) => !a.has(v(u))).map((u) => u.itemId);
  return {
    before: e.surface,
    after: t.surface,
    compared: p,
    mismatches: o,
    missing: l,
    added: c,
    skipped: d
  };
}, kn = "trifold", vn = 1e-3, ce = (e) => typeof e == "number" && Number.isFinite(e) ? e : null, re = (e) => e !== null && e > 0 ? e : 0, C = (e) => Math.round(e * 100) / 100, de = (e, t) => e !== void 0 ? e : t, F = (e, t) => ce(de(e, t)), Pn = ({
  foldLine: e,
  foldPanelWidths: t,
  paperWidth: n
}) => {
  if (e !== kn) return { kind: "none" };
  const s = Array.isArray(t) ? t.map(ce) : [];
  if (s.length !== 3) return { kind: "invalid", reason: "panel-count" };
  if (s.some((o) => o === null || o <= 0))
    return { kind: "invalid", reason: "panel-not-positive" };
  const r = ce(n);
  if (r === null || r <= 0)
    return { kind: "invalid", reason: "paper-unknown" };
  const i = s, a = i[0] + i[1] + i[2];
  return a > r + vn ? { kind: "invalid", reason: "panels-exceed-paper" } : {
    kind: "valid",
    panelWidthsIn: i,
    bleedPerSideIn: Math.max(0, (r - a) / 2)
  };
}, Fn = (e) => {
  if (!e) return { kind: "not-trifold" };
  const t = F(e.paper_width, e.paperWidth), n = Pn({
    foldLine: de(e.fold_line, e.foldLine),
    foldPanelWidths: de(e.fold_panel_widths, e.foldPanelWidths),
    paperWidth: t
  });
  if (n.kind === "none") return { kind: "not-trifold" };
  if (n.kind === "invalid" || t === null)
    return { kind: "invalid-trifold" };
  const { panelWidthsIn: s, bleedPerSideIn: r } = n, [i, a] = s, o = F(
    e.margin_center_vertical,
    e.marginCenterVertical
  );
  return {
    kind: "trifold",
    foldFractions: [
      (r + i) / t,
      (r + i + a) / t
    ],
    paperWidthPx: t * Ue,
    marginLeft: re(
      F(e.margin_left, e.marginLeft)
    ),
    marginRight: re(
      F(e.margin_right, e.marginRight)
    ),
    foldMarginWidth: re(o)
  };
}, Me = () => ({ foldMargins: [], foldMarks: [], panelCenters: [] }), Hn = (e, t, n) => {
  if (e.kind === "not-trifold") return { kind: "not-trifold" };
  if (e.kind === "invalid-trifold")
    return { kind: "invalid-trifold", ...Me() };
  if (!Number.isInteger(t) || t < 1 || !Number.isFinite(n) || n <= 0)
    return { kind: "trifold", ...Me() };
  const [s, r] = e.foldFractions, a = (t % 2 === 1 ? [s, r] : [1 - r, 1 - s]).map((u) => u * n), o = n / e.paperWidthPx, l = e.foldMarginWidth * o, d = l / 2, [p, c] = a;
  return {
    kind: "trifold",
    foldMargins: l > 0 ? a.map((u) => ({
      center: C(u),
      start: C(u - d),
      end: C(u + d),
      width: C(l)
    })) : [],
    foldMarks: a.map(C),
    panelCenters: [
      (e.marginLeft * o + p - d) / 2,
      (p + d + c - d) / 2,
      (c + d + n - e.marginRight * o) / 2
    ].map(C)
  };
}, Fr = (e, t, n) => {
  const s = Hn(Fn(e), t, n);
  return s.kind === "not-trifold" ? void 0 : s.foldMargins;
}, Hr = (e) => {
  const t = Number(e);
  return Number.isFinite(t) && t >= Ct;
}, $n = /* @__PURE__ */ new Set([
  ae.PROOF_SENT,
  ae.FINALIZED
]), zn = (e) => e === ae.FINALIZED, Un = (e) => $n.has(e), $r = (e, t, n) => {
  const s = Un(e);
  return {
    finalizedPdf: zn(e) ? (n == null ? void 0 : n.url) ?? null : null,
    proofPdf: s ? (t == null ? void 0 : t.url) ?? null : null,
    proofGalleryUrl: s ? (t == null ? void 0 : t.galleryUrl) ?? null : null
  };
}, Dn = (e) => e && (e.startsWith("http://") || e.startsWith("https://")) ? e : null, zr = (e) => {
  const { baseUrl: t, pdfId: n, galleryToken: s, screenshotUrls: r } = e;
  return !n || !s || !t || !(r != null && r.length) ? null : `${t}/proof-gallery/${n}/${s}`;
}, Ur = (e) => {
  const { isProof: t, isComplete: n, url: s, galleryUrl: r } = e, i = t && n && !r && !!s, a = Dn(s);
  return {
    downloadUrl: t && !i ? null : a,
    viewUrl: t && !i ? r : a
  };
}, Dr = (e) => {
  const t = /* @__PURE__ */ new Map();
  for (const n of e)
    n.productId && !t.has(n.productId) && t.set(n.productId, n.id);
  return t;
}, Xr = (e, t, n) => [...e].sort().map(
  (s) => `${s}:${t.get(s) ?? ""}:${(n == null ? void 0 : n.get(s)) ?? ""}`
).join("|"), Gr = (e) => !!e.revokedAt || /* @__PURE__ */ new Date() > e.expiresAt, Xn = /[^a-zA-Z0-9._-]/g, xe = 255, Gn = (e, t) => {
  const n = e.lastIndexOf(".");
  if (n <= 0 || e.length - n >= t) return e.slice(0, t);
  const r = e.slice(n);
  return e.slice(0, t - r.length) + r;
}, jn = (e) => e.replace(Xn, "_"), Wn = (e) => {
  const t = jn(e);
  return t.length <= xe ? t : Gn(t, xe);
}, et = /* @__PURE__ */ new Set([`
`, "\r", "\f"]), Vn = (e) => {
  const t = [];
  let n = "", s = null, r = 0;
  for (const i of e) {
    if (s !== null)
      (i === s || et.has(i)) && (s = null);
    else if (i === '"' || i === "'") s = i;
    else if (i === "(") r += 1;
    else if (i === ")") r = Math.max(0, r - 1);
    else if (i === ";" && r === 0) {
      t.push(n), n = "";
      continue;
    }
    n += i;
  }
  return t.push(n), t.flatMap((i) => {
    const a = i.indexOf(":");
    if (a < 0) return [];
    const o = i.slice(0, a).trim().toLowerCase(), l = i.slice(a + 1).trim();
    return o.length > 0 ? [{ property: o, value: l }] : [];
  });
}, Yn = 2e3, ue = String.raw`(?:#[0-9a-f]{3,8}|[a-z]+|(?:rgba?|hsla?)\([^();]*\))`, D = String.raw`(?:[-+]?(?:\d+(?:\.\d*)?|\.\d+)(?:px|pt|pc|em|rem|ex|ch|%|cm|mm|in|q|vw|vh|vmin|vmax)?|[a-z-]+)`, B = (e) => new RegExp(String.raw`^(?:${e})$`, "i"), ie = B(ue), m = B(String.raw`${D}(?:\s+${D}){0,3}`), S = B(
  String.raw`[a-z][a-z0-9-]*(?:\s+[a-z][a-z0-9-]*){0,3}`
), Kn = B(
  String.raw`(?:"[^"\n\r\f]*(?:"|$)|'[^'\n\r\f]*(?:'|$)|[\w\s,.-])+`
), H = B(
  String.raw`(?:${D}|${ue})(?:\s+(?:${D}|${ue})){0,3}`
), qn = {
  "font-family": Kn,
  "font-size": m,
  "font-weight": m,
  "font-style": S,
  "text-align": S,
  "text-decoration": H,
  "text-transform": S,
  "line-height": m,
  "letter-spacing": m,
  color: ie,
  "background-color": ie,
  margin: m,
  "margin-top": m,
  "margin-right": m,
  "margin-bottom": m,
  "margin-left": m,
  padding: m,
  "padding-top": m,
  "padding-right": m,
  "padding-bottom": m,
  "padding-left": m,
  display: S,
  width: m,
  height: m,
  "vertical-align": m,
  border: H,
  "border-collapse": S,
  "-webkit-text-stroke": H,
  // Visible typography and table borders that production obituaries carry
  // beyond the census's list.
  "border-color": H,
  "border-style": S,
  "border-width": m,
  "font-variant": S,
  "text-decoration-line": S,
  "text-decoration-style": S,
  "text-decoration-color": ie,
  "text-indent": m,
  "white-space": S,
  "word-spacing": m
}, Jn = (e) => {
  if (/[\\<>{}]|\/\*/.test(e)) return !0;
  const t = e.replace(/"[^"\n\r\f]*"?|'[^'\n\r\f]*'?/g, '""').replace(/(?:rgba?|hsla?)\([^();]*\)/gi, "");
  return /[()@]/.test(t);
}, Zn = /^\s*important\s*$/i, Qn = (e) => {
  let t = "";
  for (const n of e)
    n.charCodeAt(0) > 31 && (t += n);
  return t;
}, es = (e) => {
  let t = null, n = !1;
  for (const s of e)
    if (t !== null) {
      if (s === t && n) return !0;
      s === t && (t = null), n = !1;
    } else (s === '"' || s === "'") && (t = s, n = !0);
  return !1;
}, tt = (e) => {
  const t = e.lastIndexOf("!");
  return t < 0 || !Zn.test(e.slice(t + 1)) ? e : e.slice(0, t).trimEnd();
}, ts = ({
  property: e,
  value: t
}) => {
  if (t.length > Yn || t.includes(";") || t.includes("\uFEFF") || es(Qn(nt(t))))
    return !1;
  const n = qn[e];
  return n !== void 0 && !Jn(t) && n.test(tt(t));
}, nt = (e) => {
  let t = null;
  for (const s of e)
    t !== null ? (s === t || et.has(s)) && (t = null) : (s === '"' || s === "'") && (t = s);
  if (t !== null) return `${e}${t}`;
  const n = tt(e);
  return n === e ? e : `${n} !important`;
}, ns = new Set(
  "a abbr address applet area article aside audio b base basefont bdi bdo bgsound big blink blockquote body br button canvas caption center cite code col colgroup data datalist dd del details dfn dialog dir div dl dt em embed fieldset figcaption figure font footer form frame frameset h1 h2 h3 h4 h5 h6 head header hgroup hr html i iframe image img input ins isindex kbd keygen label legend li link listing main map mark marquee math menu meta meter nav nobr noembed noframes noscript object ol optgroup option output p param picture plaintext pre progress q rb rp rt rtc ruby s samp script search section select slot small source spacer span strike strong style sub summary sup svg table tbody td template textarea tfoot th thead time title tr track tt u ul var video wbr xml xmp".split(" ")
), ss = new Set(
  "abbr accesskey action align alink allow allowfullscreen alt autocomplete autofocus autoplay background bgcolor border cellpadding cellspacing charset checked cite class clear color cols colspan content contenteditable controls coords crossorigin data datetime decoding default dir disabled download draggable enctype face for form formaction frame frameborder headers height hidden href hreflang hspace http-equiv id inert ismap lang link list loading loop marginheight marginwidth max maxlength media method min multiple muted name nohref noshade nowrap open pattern ping placeholder poster preload readonly referrerpolicy rel required reversed role rows rowspan rules sandbox scope scrolling selected shape size sizes span spellcheck src srcdoc srclang srcset start step style summary tabindex target text title translate type usemap valign value vlink vspace width wrap xmlns case-detail locked fontsize fontfamily fontweight lineheight textalignment hastrailingparagraphbreakonpaste".split(" ")
), Be = /^(?:o|w|v|m|x|st1|st2|xml|xmlns|xlink):[a-z][a-z0-9-]{0,40}$/i, rs = (e, t) => {
  const n = t.toLowerCase();
  return e === "element" || e === "unwrapped" ? ns.has(n) || Be.test(n) ? n : "other" : e === "attribute" || e === "url" ? ss.has(n) || Be.test(n) || /^on[a-z]{1,40}$/.test(n) || /^(?:data|aria)-[a-z0-9-]{1,60}$/.test(n) ? n : "other" : e === "style" && /^-{0,2}[a-z][a-z0-9-]{0,60}$/.test(n) ? n : "other";
}, is = {
  script: _.SCRIPT_DATA,
  style: _.RAWTEXT,
  xmp: _.RAWTEXT,
  iframe: _.RAWTEXT,
  noembed: _.RAWTEXT,
  noframes: _.RAWTEXT,
  noscript: _.RAWTEXT,
  title: _.RCDATA,
  textarea: _.RCDATA,
  plaintext: _.PLAINTEXT
}, os = /* @__PURE__ */ new Set([
  "script",
  "style",
  "xmp",
  "iframe",
  "noembed",
  "noframes",
  "noscript",
  "title",
  "template"
]), ke = /* @__PURE__ */ new Set(["svg", "math"]), ve = /* @__PURE__ */ new Set([
  "address",
  "article",
  "blockquote",
  "br",
  "caption",
  "center",
  "dd",
  "div",
  "dl",
  "dt",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "hr",
  "li",
  "ol",
  "p",
  "section",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "tr",
  "ul"
]), as = (e) => /^\s*\[(?:if|endif)\b[^\]]*\]\s*$/i.test(e) ? "" : e.replace(/^\s*\[if\b[^\]]*\]>(?:\s*<!)?/i, "").replace(/<!\[endif\]\s*$/i, "").replace(/^\s*<!\[endif\]/i, ""), ls = 2, st = (e, t, n) => {
  const s = [], r = [];
  let i = 0;
  const a = new bt(
    {},
    {
      onCharacter: (o) => {
        r.length === 0 && s.push(o.chars);
      },
      onWhitespaceCharacter: (o) => {
        r.length === 0 && s.push(o.chars);
      },
      onNullCharacter: () => {
      },
      onStartTag: (o) => {
        const l = o.tagName;
        if (ve.has(l) && s.push(`
`), ke.has(l)) {
          o.selfClosing || (i += 1);
          return;
        }
        if (i > 0) return;
        const d = is[l];
        d !== void 0 && (a.state = d), os.has(l) && r.push(l);
      },
      onEndTag: (o) => {
        const l = o.tagName;
        ve.has(l) && s.push(`
`), ke.has(l) && i > 0 && (i -= 1), r[r.length - 1] === l && r.pop();
      },
      onComment: (o) => {
        !t || n >= ls || r.length > 0 || s.push(
          `
`,
          st(as(o.data), t, n + 1),
          `
`
        );
      },
      onDoctype: () => {
      },
      onEof: () => {
      }
    }
  );
  return a.write(e, !0), s.join("");
}, ye = (e, { includeComments: t = !1 } = {}) => st(e, t, 0).split(`
`).map((n) => n.replace(/\s+/g, " ").trim()).filter((n) => n.length > 0), Pe = (e) => ye(e).join("").replace(/\s+/g, "").length, cs = 50;
class X {
  constructor() {
    Q(this, "counts", {});
    Q(this, "namesByKind", /* @__PURE__ */ new Map());
  }
  add(t, n) {
    let s = n === void 0 ? t : `${t}:${rs(t, n)}`;
    if (n !== void 0 && !(s in this.counts)) {
      const r = this.namesByKind.get(t) ?? 0;
      r >= cs ? s = `${t}:other` : this.namesByKind.set(t, r + 1);
    }
    this.counts[s] = (this.counts[s] ?? 0) + 1;
  }
  get total() {
    return Object.values(this.counts).reduce((t, n) => t + n, 0);
  }
}
const pe = (e, t, n) => {
  const s = ye(e, { includeComments: n }), r = [];
  let i = 0, a = !1;
  for (const o of s) {
    if (i + o.length > t) {
      const l = t - i;
      l > 0 && r.push(o.slice(0, l)), a = !0;
      break;
    }
    r.push(o), i += o.length;
  }
  return {
    html: r.map((o) => `<p>${he(o)}</p>`).join(""),
    truncated: a
  };
}, rt = /* @__PURE__ */ new Set([
  "a",
  "b",
  "blockquote",
  "br",
  "caption",
  "center",
  "dd",
  "div",
  "dl",
  "dt",
  "em",
  "font",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "hr",
  "i",
  "img",
  "li",
  "ol",
  "p",
  "s",
  "section",
  "small",
  "span",
  "strong",
  "sub",
  "sup",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "tr",
  "u",
  "ul"
]), ds = /* @__PURE__ */ new Set([
  "applet",
  "audio",
  "base",
  "canvas",
  "embed",
  "frame",
  "frameset",
  "head",
  "iframe",
  "input",
  "link",
  "math",
  "meta",
  "noembed",
  "noframes",
  "noscript",
  "object",
  "option",
  "optgroup",
  "param",
  "picture",
  "script",
  "select",
  "source",
  "style",
  "svg",
  "template",
  "title",
  "track",
  "video",
  "xmp"
]), it = /* @__PURE__ */ new Set([
  "case-detail",
  "class",
  "contenteditable",
  "data-case-detail",
  "data-case-detail-table",
  "data-had-space",
  "data-honorary-pallbearers-heading",
  "data-locked",
  "data-mce-bogus",
  "data-mce-style",
  "data-persistent-font-family",
  "data-persistent-font-size",
  "data-preserve-styles",
  "data-properties",
  "data-style",
  "data-template",
  "data-template-item",
  "data-user-hidden",
  "dir",
  "fontfamily",
  "fontsize",
  "fontweight",
  "lineheight",
  "locked",
  "style",
  "textalignment"
]), ot = {
  a: /* @__PURE__ */ new Set(["href", "target", "rel"]),
  img: /* @__PURE__ */ new Set(["src", "alt", "width", "height"]),
  td: /* @__PURE__ */ new Set(["colspan", "rowspan", "align", "valign"]),
  th: /* @__PURE__ */ new Set(["colspan", "rowspan", "align", "valign"]),
  font: /* @__PURE__ */ new Set(["color", "face", "size"]),
  p: /* @__PURE__ */ new Set(["align"]),
  div: /* @__PURE__ */ new Set(["align"]),
  table: /* @__PURE__ */ new Set(["align"])
}, us = /* @__PURE__ */ new Set(["style", "data-mce-style"]), ps = /* @__PURE__ */ new Set([
  "http",
  "https",
  "mailto",
  "tel"
]), fs = /* @__PURE__ */ new Set(["http", "https"]), ms = /^data:image\/(?:png|jpeg|gif|webp);base64,[a-z0-9+/=\s]*$/i, hs = {
  dir: /^(?:ltr|rtl|auto)$/i,
  contenteditable: /^(?:true|false)$/i,
  target: /^(?:_blank|_self|_parent|_top)$/i,
  colspan: /^\d{1,4}$/,
  rowspan: /^\d{1,4}$/,
  width: /^\d{1,5}%?$/,
  height: /^\d{1,5}%?$/,
  align: /^(?:left|right|center|justify|top|middle|bottom)$/i,
  valign: /^(?:top|middle|bottom|baseline)$/i,
  color: /^#?[\w]{1,32}$/,
  face: /^[\w\s,'".-]{1,200}$/,
  size: /^[+-]?\d{1,2}$/
}, G = Lt.NS.HTML, at = 512;
class _e extends Error {
  constructor() {
    super(`HTML nests deeper than ${at} elements`), this.name = "HtmlTooDeepError";
  }
}
const gs = () => {
  const e = /* @__PURE__ */ new WeakMap(), t = (n) => {
    let s = 1, r = n;
    for (; r; ) {
      if (s += 1, s > at) throw new _e();
      r = ("parentNode" in r ? r.parentNode : null) ?? e.get(r);
    }
    return s;
  };
  return {
    ...R,
    appendChild(n, s) {
      t(n), R.appendChild(n, s);
    },
    insertBefore(n, s, r) {
      t(n), R.insertBefore(n, s, r);
    },
    setTemplateContent(n, s) {
      e.set(s, n), R.setTemplateContent(n, s);
    }
  };
}, lt = (e) => {
  const t = gs(), n = R.createElement("body", G, []);
  return Rt(n, e, { treeAdapter: t });
}, Es = /* @__PURE__ */ new Set([
  "area",
  "base",
  "basefont",
  "bgsound",
  "br",
  "col",
  "embed",
  "frame",
  "hr",
  "img",
  "input",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
]), Ts = /* @__PURE__ */ new Set([
  "style",
  "script",
  "xmp",
  "iframe",
  "noembed",
  "noframes",
  "plaintext",
  "noscript"
]), ys = /* @__PURE__ */ new Set(["pre", "textarea", "listing"]), _s = (e) => e.replace(
  /[&\u00a0<>]/g,
  (t) => t === "&" ? "&amp;" : t === " " ? "&nbsp;" : t === "<" ? "&lt;" : "&gt;"
), Ss = (e) => e.replace(
  /[&\u00a0"<>]/g,
  (t) => t === "&" ? "&amp;" : t === " " ? "&nbsp;" : t === '"' ? "&quot;" : t === "<" ? "&lt;" : "&gt;"
), j = (e) => "tagName" in e, ct = (e) => e.nodeName === "template" && "content" in e ? e.content.childNodes : e.childNodes, Is = (e) => {
  const t = e.attrs.map((n) => ` ${n.prefix ? `${n.prefix}:${n.name}` : n.name}="${Ss(n.value)}"`).join("");
  return `<${e.tagName}${t}>`;
}, dt = (e) => {
  const t = [], n = [...e].reverse().map((s) => ({ node: s }));
  for (; n.length > 0; ) {
    const s = n.pop();
    if ("close" in s) {
      t.push(s.close);
      continue;
    }
    const { node: r } = s;
    if (r.nodeName === "#text" && "value" in r) {
      const i = r.parentNode, a = i !== null && j(i) && i.namespaceURI === G && Ts.has(i.tagName);
      t.push(a ? r.value : _s(r.value));
    } else if (r.nodeName === "#comment" && "data" in r)
      t.push(`<!--${r.data}-->`);
    else if (j(r)) {
      t.push(Is(r));
      const i = r.namespaceURI === G;
      if (i && Es.has(r.tagName)) continue;
      const a = ct(r), o = a[0];
      i && ys.has(r.tagName) && (o == null ? void 0 : o.nodeName) === "#text" && "value" in o && o.value.startsWith(`
`) && t.push(`
`), n.push({ close: `</${r.tagName}>` });
      for (let l = a.length - 1; l >= 0; l -= 1)
        n.push({ node: a[l] });
    }
  }
  return t.join("");
}, jr = (e) => dt(lt(e).childNodes), As = 4, ut = (e, t) => {
  let n = e;
  for (let s = 0; s < As; s += 1) {
    const r = lt(n);
    t(r, s);
    const i = dt(r.childNodes);
    if (i === n) return { html: n, stable: !0 };
    n = i;
  }
  return { html: n, stable: !1 };
}, Y = (e) => (
  // eslint-disable-next-line no-control-regex
  e.replace(/[\u0000-\u0020]/g, "").toLowerCase()
), Fe = (e) => {
  const t = /^([a-z][a-z0-9+.-]*):/.exec(Y(e));
  return t ? t[1] : null;
}, ws = (e) => Y(e).startsWith("javascript:"), k = 5e5, Ns = 0.5, Cs = 2e4, Os = (e) => {
  let t = 0;
  for (let n = e.indexOf("<"); n >= 0; n = e.indexOf("<", n + 1))
    t += 1;
  return t;
}, bs = (e, t, n, s) => {
  if (us.has(t)) {
    const a = Vn(n).filter((l) => ts(l) ? !0 : (s.add("style", l.property), !1));
    if (a.length === 0) return null;
    const o = a.map(
      ({ property: l, value: d }) => `${l}: ${nt(d)}`
    ).join("; ");
    return n.trimEnd().endsWith(";") ? `${o};` : o;
  }
  if (t === "href") {
    const i = Fe(n);
    return i !== null && !ps.has(i) ? (s.add("url", t), null) : n;
  }
  if (t === "src" && e.tagName === "img") {
    const i = Fe(n);
    return i !== null && fs.has(i) || ms.test(n.trim()) ? n : (s.add("url", t), null);
  }
  const r = hs[t];
  return r !== void 0 && !r.test(n.trim()) ? (s.add("attribute", t), null) : n;
}, Ls = (e, t) => {
  const n = ot[e.tagName];
  let s = !1;
  const r = e.attrs.flatMap((i) => {
    const a = i.prefix ? `${i.prefix}:${i.name}` : i.name;
    if (!it.has(a) && !(n != null && n.has(a)))
      return t.add("attribute", a), s = !0, [];
    const o = bs(e, a, i.value, t);
    return o === null ? (s = !0, []) : (o !== i.value && (s = !0), [{ ...i, value: o }]);
  });
  if (e.tagName === "a" && r.some(
    (i) => i.name === "target" && Y(i.value) === "_blank"
  )) {
    const i = r.find((o) => o.name === "rel"), a = new Set(
      ((i == null ? void 0 : i.value) ?? "").toLowerCase().split(/\s+/).filter(Boolean)
    );
    if (!a.has("noopener") || !a.has("noreferrer")) {
      a.add("noopener"), a.add("noreferrer");
      const o = [...a].join(" ");
      i ? i.value = o : r.push({ name: "rel", value: o }), s = !0;
    }
  }
  return e.attrs = r, s;
}, Rs = (e, t) => {
  let n = !1;
  const s = [e];
  for (; s.length > 0; ) {
    const r = s.pop(), i = [...r.childNodes].reverse(), a = [];
    for (; i.length > 0; ) {
      const o = i.pop();
      if (o.nodeName === "#text") {
        a.push(o);
        continue;
      }
      if (!j(o)) {
        t.add(o.nodeName === "#comment" ? "comment" : o.nodeName), n = !0;
        continue;
      }
      const l = o.tagName;
      if (o.namespaceURI !== G || ds.has(l)) {
        t.add("element", l), n = !0;
        continue;
      }
      if (!rt.has(l)) {
        t.add("unwrapped", l);
        for (let d = o.childNodes.length - 1; d >= 0; d -= 1)
          i.push(o.childNodes[d]);
        n = !0;
        continue;
      }
      Ls(o, t) && (n = !0), a.push(o), s.push(o);
    }
    for (const o of a) o.parentNode = r;
    r.childNodes = a;
  }
  return n;
}, fe = (e, t, n, s, r = !1) => ({
  html: t,
  changed: t !== e,
  stripped: n.counts,
  strippedCount: n.total,
  fallback: s,
  unrecoverable: e.trim().length > 0 && t.trim().length === 0,
  truncated: r
}), He = k * 4, L = (e, t, n, s) => {
  const r = e.length > He ? e.slice(0, He) : e, i = pe(
    r,
    k,
    s
  );
  return fe(
    e,
    i.html,
    t,
    n,
    i.truncated || r !== e
  );
}, pt = (e) => {
  const t = new X();
  if (e.length > k || Os(e) > Cs)
    return L(e, t, "oversize", !1);
  let n;
  try {
    n = ut(
      e,
      (a, o) => Rs(a, o === 0 ? t : new X())
    );
  } catch (a) {
    if (a instanceof _e)
      return L(e, t, "too-deep", !1);
    throw a;
  }
  if (!n.stable) return L(e, t, "unstable", !1);
  const { html: s } = n;
  if (t.total === 0) return fe(e, s, t, null);
  const r = Pe(e), i = Pe(s);
  return i === 0 && ye(e, { includeComments: !0 }).join("").trim().length > 0 ? L(e, t, "emptied", !0) : r > 0 && i / r < Ns ? L(e, t, "emptied", !1) : fe(e, s, t, null);
}, Wr = (e) => pt(e).html, Ms = /* @__PURE__ */ new Set(["script", "meta", "base", "link", "noscript"]), xs = /* @__PURE__ */ new Set([
  "href",
  "xlink:href",
  "src",
  "action",
  "formaction",
  "data",
  "poster",
  "background"
]), Bs = /* @__PURE__ */ new Set(["to", "from", "values", "by"]), ks = "about:invalid", vs = (e, t) => {
  let n = !1;
  return e.attrs = e.attrs.flatMap((s) => {
    const r = (s.prefix ? `${s.prefix}:${s.name}` : s.name).toLowerCase();
    return r.startsWith("on") || r === "srcdoc" ? (t.add("attribute", r), n = !0, []) : (xs.has(r) ? ws(s.value) : Bs.has(r) && Y(s.value).includes("javascript:")) ? (t.add("url", r), n = !0, [{ ...s, value: ks }]) : [s];
  }), n;
}, Ps = (e, t) => {
  let n = !1;
  const s = [e];
  for (; s.length > 0; ) {
    const r = s.pop(), i = ct(r), a = [];
    for (const o of i) {
      if (!j(o)) {
        a.push(o);
        continue;
      }
      if (Ms.has(o.tagName.toLowerCase())) {
        t.add("element", o.tagName), n = !0;
        continue;
      }
      vs(o, t) && (n = !0), a.push(o), s.push(o);
    }
    a.length !== i.length && (r.nodeName === "template" && "content" in r ? r.content.childNodes = a : r.childNodes = a);
  }
  return n;
}, oe = (e, t, n, s, r = !1) => ({
  html: t,
  changed: t !== e,
  stripped: n.counts,
  strippedCount: n.total,
  fallback: s,
  unrecoverable: e.trim().length > 0 && t.trim().length === 0,
  truncated: r
}), Fs = (e) => {
  const t = new X();
  let n;
  try {
    n = ut(
      e,
      (r, i) => Ps(r, i === 0 ? t : new X())
    );
  } catch (r) {
    if (!(r instanceof _e)) throw r;
    const i = pe(e, e.length, !1);
    return oe(e, i.html, t, "too-deep", i.truncated);
  }
  if (n.stable) return oe(e, n.html, t, null);
  const s = pe(e, e.length, !1);
  return oe(e, s.html, t, "unstable", s.truncated);
}, Vr = (e) => Fs(e).html, Hs = ["obituary", "orderOfService"], ft = (e) => {
  const t = e.length <= k && ge(e), n = t ? mn(e) : null, s = n ?? (t ? gn(e) : e), r = pt(s);
  return { html: r.html, report: r, convertedFromXaml: n !== null };
}, Yr = (e) => e.length <= k && ge(e) ? ft(e).html : e, Kr = (e) => {
  const t = { ...e }, n = [];
  for (const s of Hs) {
    const r = e[s];
    if (typeof r != "string") continue;
    const { html: i, report: a, convertedFromXaml: o } = ft(r);
    t[s] = i, (a.strippedCount > 0 || a.fallback !== null || o) && n.push({
      field: s,
      strippedCount: a.strippedCount,
      stripped: a.stripped,
      fallback: a.fallback,
      unrecoverable: a.unrecoverable,
      convertedFromXaml: o
    });
  }
  return { value: t, reports: n };
}, $s = "script,iframe,object,embed,meta,base,link,form,input,textarea,button,select,animate,animatemotion,animatetransform,set", zs = [
  `@[${[...it].join("|")}]`,
  ...[...rt].map((e) => {
    const t = ot[e];
    return t ? `${e}[${[...t].join("|")}]` : e;
  })
].join(","), qr = {
  invalid_elements: $s,
  valid_elements: zs,
  extended_valid_elements: "span[class|type|data-case-detail|data-style],p[class|type|data-case-detail|data-style],div[style|data-style]"
}, Jr = (e) => e.map((t, n) => ({
  row: t,
  index: n,
  place: Number(t.sequence) || Number.POSITIVE_INFINITY
})).sort((t, n) => t.place - n.place || t.index - n.index).map(({ row: t }) => t), Us = 3, Ds = (e) => {
  if (typeof e != "object" || e === null)
    return !1;
  if ("isNetwork" in e && e.isNetwork === !0)
    return !0;
  const t = "status" in e ? e.status : void 0;
  return typeof t == "number" && (t === 408 || t >= 500);
}, Zr = async (e, t, n = {}) => Kt(
  async () => {
    let s;
    try {
      s = await fetch(e, {
        method: "PUT",
        body: t,
        headers: {
          "Content-Type": t.type
        }
      });
    } catch (r) {
      const i = r instanceof Error ? r.message : String(r);
      throw Object.assign(new Error(i), {
        isNetwork: !0,
        cause: r
      });
    }
    if (!s.ok)
      throw Object.assign(
        new Error(
          `S3 upload failed: ${s.status} ${s.statusText}`
        ),
        { status: s.status }
      );
  },
  {
    isRetryable: Ds,
    maxAttempts: Us,
    onRetry: n.onRetry
  }
), Xs = {
  autocorrect: "autoCorrect",
  autocapitalize: "autoCapitalize",
  spellcheck: "spellCheck"
}, Gs = /* @__PURE__ */ new Set([
  "writingsuggestions"
]), Qr = () => Object.fromEntries(
  Object.entries(De).filter(([e]) => !Gs.has(e)).map(([e, t]) => [Xs[e] ?? e, t])
), ei = (e) => {
  for (const [t, n] of Object.entries(De))
    e.setAttribute(t, n);
}, js = ["image/"], Se = (e) => ({
  valid: !1,
  error: e
}), Ws = (e) => e === 0 ? Se({
  code: x.BAD_REQUEST,
  message: "File is empty"
}) : null, Vs = (e) => e > ee ? Se({
  code: x.FILE_TOO_LARGE,
  message: `File exceeds maximum size of ${ee / (1024 * 1024)}MB`,
  data: {
    maxSize: `${ee / (1024 * 1024)}MB`
  }
}) : null, Ys = (e) => js.some(
  (n) => e.startsWith(n)
) ? null : Se({
  code: x.UNSUPPORTED_IMAGE_FORMAT,
  message: "File must be an image"
}), mt = (e) => Ws(e.size) ?? Vs(e.size) ?? Ys(e.mimeType) ?? { valid: !0 }, Ks = (e, t) => ({
  valid: !1,
  error: {
    ...e,
    data: { ...e.data, fileName: t }
  }
}), qs = (e) => {
  const t = mt({ size: e.size, mimeType: e.type });
  return t.valid ? null : Ks(t.error, e.name);
}, Js = (e, t) => new File([e], t, {
  type: e.type,
  lastModified: e.lastModified
}), Zs = (e) => {
  const t = Wn(e.name);
  return t !== e.name ? Js(e, t) : e;
}, ti = (e) => qs(e) ?? { valid: !0, sanitizedFile: Zs(e) }, ni = (e) => {
  const t = mt(e);
  t.valid || We({
    code: t.error.code,
    message: t.error.message,
    data: t.error.data
  });
}, si = (e, t) => {
  e.startsWith(`temp/${t}/`) || We({
    code: x.BAD_REQUEST,
    message: "s3Key does not belong to this case"
  });
};
export {
  xr as $,
  qt as A,
  _r as B,
  Qt as C,
  Jt as D,
  Dt as E,
  M as F,
  en as G,
  wr as H,
  Sr as I,
  Ir as J,
  Cr as K,
  Or as L,
  Nr as M,
  tn as N,
  br as O,
  ge as P,
  an as Q,
  gn as R,
  ln as S,
  mn as T,
  Lr as U,
  zt as V,
  Ut as W,
  Tr as X,
  Rr as Y,
  Mr as Z,
  En as _,
  ti as a,
  Br as a0,
  kr as a1,
  Sn as a2,
  ne as a3,
  Qe as a4,
  Mn as a5,
  Pr as a6,
  se as a7,
  b as a8,
  In as a9,
  Vr as aA,
  Fs as aB,
  at as aC,
  jr as aD,
  Hs as aE,
  Yr as aF,
  ft as aG,
  Kr as aH,
  zs as aI,
  qr as aJ,
  $s as aK,
  Jr as aL,
  Kt as aM,
  Zr as aN,
  ei as aO,
  Qr as aP,
  Ft as aQ,
  Er as aR,
  Pt as aS,
  $t as aT,
  V as aU,
  Ht as aV,
  gr as aW,
  Rn as aa,
  Cn as ab,
  vr as ac,
  kn as ad,
  Fr as ae,
  Pn as af,
  Hn as ag,
  Fn as ah,
  Hr as ai,
  $r as aj,
  Ur as ak,
  zr as al,
  Dn as am,
  zn as an,
  Un as ao,
  Xr as ap,
  Gr as aq,
  Dr as ar,
  Wn as as,
  he as at,
  k as au,
  Cs as av,
  Ns as aw,
  Wr as ax,
  pt as ay,
  ks as az,
  ni as b,
  si as c,
  or as d,
  Bt as e,
  ir as f,
  ar as g,
  kt as h,
  Mt as i,
  lr as j,
  me as k,
  dr as l,
  vt as m,
  pr as n,
  fr as o,
  Xe as p,
  mr as q,
  ur as r,
  hr as s,
  We as t,
  cr as u,
  mt as v,
  Gt as w,
  yr as x,
  Ar as y,
  $ as z
};
